
import axios from 'axios'

const env = (process.env.NODE_ENV === 'production')

const config = () => {
  return {
    url: env ? 'https://fdc-api.brique.kr' : 'http://localhost',
    port: env ? '' : ':'.concat('20004')
  }
}

export default {
  commUserManageSearch: async () => {
    try {
      let response = await axios.get(config().urlVueAppIamIp + config().portVueAppIamPort + '/iam/users')
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  commUserManageSearchByParam: async (params) => {
    try {
      let response = await axios.get(config().urlVueAppIamIp + config().portVueAppIamPort + '/iam/users', { params: params })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  faultActionPlanList: async (payload) => {
    try {
      let response = await axios.get(config().url + config().port + '/fdc/fas/fault-action-plan/list', { params: payload })
      return response.data === null ? [] : response.data
    } catch (error) {
      console.log(error)
    }
  },
  saveFaultActionPlan: async (payload) => {
    try {
      let response = await axios.post(config().url + config().port + '/fdc/fas/fault-action-plan/save', payload)
      return response
    } catch (error) {
      console.log(error)
    }
  }
}
